import { readCookie } from '@zapier/cookies';
export function getCurrentAccountID() {
    return parseInt(readCookie('currentAccountId'), 10);
}
//# sourceMappingURL=getCurrentAccountID.js.map